import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllAssetAllocationCountReport = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/assetallocation/count/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Attendance Report');
        }
    }
);

export const fetchAllAssetAllocationCountReportMonthly = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/assetallocation/monthly/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Attendance Report');
        }
    }
);